import defaultCopy, {
  companySpecificOverrides,
  RentableGroupCalculatorCopy,
} from "../const/rentableGroupCalculatorCopy";

const getRentableGroupCalculatorCopy = (
  companyId?: string
): RentableGroupCalculatorCopy => {
  if (!companyId || !companySpecificOverrides[companyId]) {
    return defaultCopy;
  }

  return {
    ...defaultCopy,
    ...companySpecificOverrides[companyId],
  };
};

export default getRentableGroupCalculatorCopy;
